export { default as MainTitle } from './MainTitle';
